import * as base from './base';
import * as types from 'constants/action-types';
import * as api from 'api';

export const fetchClassrooms = (q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(api.fetchClassrooms, setClassrooms, q, page, perPage, sortOpts, extraFilters);

export const setClassrooms = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_CLASSROOMS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const fetchClassroom = (recordId) => (dispatch) =>
  api.fetchClassroom(recordId).then((response) => {
    dispatch(setCurrentClassroom(recordId, response.record));
  });

export const setCurrentClassroomPage = (page) => ({
  type: types.SET_CURRENT_CLASSROOM_PAGE,
  page,
});

export const setCurrentClassroom = (recordId, recordData) => ({
  type: types.SET_CURRENT_CLASSROOM,
  recordId,
  recordData,
});

export const clearClassroomsAfterPage = (page) => ({
  type: types.CLEAR_CLASSROOMS_AFTER_PAGE,
  page,
});

/**
 * Classroom Student
 */
export const fetchClassroomReaders = (classroomId, q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(
    (...args) => api.fetchClassroomReaders(classroomId, ...args),
    setClassroomReaders,
    q,
    page,
    perPage,
    sortOpts,
    extraFilters,
  );

export const setClassroomReaders = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_CLASSROOM_READERS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const setCurrentClassroomReaderPage = (page) => ({
  type: types.SET_CURRENT_CLASSROOM_READER_PAGE,
  page,
});

export const setCurrentClassroomReader = (recordId, recordData) => ({
  type: types.SET_CURRENT_CLASSROOM_READER,
  recordId,
  recordData,
});

export const clearClassroomReadersAfterPage = (page) => ({
  type: types.CLEAR_CLASSROOM_READERS_AFTER_PAGE,
  page,
});

/**
 * Classroom Teacher
 */
export const fetchClassroomTeachers = (classroomId, q, page = 1, perPage, sortOpts, extraFilters) =>
  base.fetchRecords(
    (q, page, perPage, sortOpts, extraFilters = {}) =>
      api.fetchUsers(q, page, perPage, sortOpts, {...extraFilters, classroomId, role: 'teacher'}),
    setClassroomTeachers,
    q,
    page,
    perPage,
    sortOpts,
    extraFilters,
  );

export const setClassroomTeachers = (records, currentPage, pageCount, totalCount, itemsPerPage) => ({
  type: types.SET_CLASSROOM_TEACHERS,
  records,
  currentPage,
  pageCount,
  totalCount,
  itemsPerPage,
});

export const setCurrentClassroomTeacherPage = (page) => ({
  type: types.SET_CURRENT_CLASSROOM_TEACHER_PAGE,
  page,
});

export const setCurrentClassroomTeacher = (recordId, recordData) => ({
  type: types.SET_CURRENT_CLASSROOM_TEACHER,
  recordId,
  recordData,
});

export const clearClassroomTeachersAfterPage = (page) => ({
  type: types.CLEAR_CLASSROOM_TEACHERS_AFTER_PAGE,
  page,
});
